<template>
  <div id="ShijoBadend" @click="onClick">
    <div class="panel"><img :src="`${publicPath}img/shijo/story1_badend01.png`" alt=""></div>
    <div class="arrow" :style="{ backgroundImage: `url(${publicPath}img/common/blue_arw.png)`}"></div>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'ShijoBadend',
    props: {
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
        timer: null
      }
    },
    mounted(){
      this.blinkArrow()
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {
    },
    methods: {
      onClick: function(){
        this.$emit('panelTap');
      },
      blinkArrow: function(){
        this.timer = setInterval(function(){
          _$('#ShijoBadend .arrow').toggle()
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #ShijoBadend {
    width: 100%;
    height: 100%;
    padding: toVW(90) toVW(60);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .panel {
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .arrow {
      background-repeat: no-repeat;
      background-size: contain;
      width: toVW(28);
      height: toVW(21);
      position: absolute;
      bottom: toVW(30);
      right: toVW(40);
      display: none;
      pointer-events: none;
    }
  }
</style>
